import { TypographyProps } from '@kizen/kds/Typography';
import { Typography } from '@kizen/kds/Typography';
import {
  ResponseLoadingWrapper,
  LoadingDotsWrapper,
  Dot,
  InlineTypographyWrapper,
} from './styles';

export const TypingIndicator = ({
  label,
  size = 'md',
  color = 'font-secondary',
  weight = 'regular',
  inline = false,
  dotSize,
}: {
  label?: string | null;
  size?: TypographyProps['size'];
  color?: TypographyProps['color'];
  weight?: TypographyProps['weight'];
  inline?: boolean;
  dotSize?: string;
}) => (
  <ResponseLoadingWrapper inline={inline}>
    <InlineTypographyWrapper>
      <Typography color={color} size={size} weight={weight} className="inline">
        {label}
        <LoadingDotsWrapper>
          <Dot style={{ animationDelay: '0s' }} color={color} size={dotSize} />
          <Dot
            style={{ animationDelay: '0.1s' }}
            color={color}
            size={dotSize}
          />
          <Dot
            style={{ animationDelay: '0.2s' }}
            color={color}
            size={dotSize}
          />
        </LoadingDotsWrapper>
      </Typography>
    </InlineTypographyWrapper>
  </ResponseLoadingWrapper>
);
